function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { l as lodash_debounce } from './index3.js';
var Portal = /*@__PURE__*/proxyCustomElement( /*#__PURE__*/function (_HTMLElement) {
  _inherits(Portal, _HTMLElement);

  var _super = _createSuper(Portal);

  function Portal() {
    var _this;

    _classCallCheck(this, Portal);

    _this = _super.call(this);

    _this.__registerHost();

    _this.observer = new MutationObserver(lodash_debounce(_this.setPosition.bind(_assertThisInitialized(_this)), 200));
    _this.offsetX = 0;
    _this.offsetY = 0;
    _this.name = "portal-".concat(String(Math.ceil(Date.now() * Math.random())));
    _this.reference = undefined;
    return _this;
  }

  _createClass(Portal, [{
    key: "handlePosition",
    value: function handlePosition() {
      this.setPosition();
    }
  }, {
    key: "componentWillLoad",
    value: function componentWillLoad() {
      var oldPortal = document.body.querySelector("#".concat(this.name));

      if (oldPortal) {
        oldPortal.remove();
      }

      this.createPortal();
    }
  }, {
    key: "componentDidLoad",
    value: function componentDidLoad() {
      this.moveElementToPortal();
      this.setPosition();
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.observer.disconnect();
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      this.setPosition();
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      this.setPosition();
    }
  }, {
    key: "createPortal",
    value: function createPortal() {
      this.portal = document.createElement('div');
      this.portal.setAttribute('id', this.name);
      this.portal.style.zIndex = '10000';
      this.portal.style.position = 'absolute';
      document.body.append(this.portal);
    }
  }, {
    key: "moveElementToPortal",
    value: function moveElementToPortal() {
      this.portal.appendChild(this.element);
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      if (this.reference) {
        var _this$reference$getBo = this.reference.getBoundingClientRect(),
            top = _this$reference$getBo.top,
            left = _this$reference$getBo.left,
            width = _this$reference$getBo.width;

        this.portal.style.top = "".concat(window.scrollY + top + this.offsetY, "px");
        this.portal.style.left = "".concat(window.scrollX + left + this.offsetX, "px");
        this.portal.style.width = "".concat(width, "px");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return h(Host, null, h("slot", null));
    }
  }, {
    key: "element",
    get: function get() {
      return this;
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "reference": ["handlePosition"]
      };
    }
  }]);

  return Portal;
}(HTMLElement), [4, "skp-portal", {
  "offsetX": [2, "offset-x"],
  "offsetY": [2, "offset-y"],
  "name": [1],
  "reference": [16]
}, [[9, "resize", "handleResize"], [11, "scroll", "handleScroll"]], {
  "reference": ["handlePosition"]
}]);

function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["skp-portal"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "skp-portal":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Portal);
        }

        break;
    }
  });
}

export { Portal as P, defineCustomElement as d };